import classNames from "classnames";
import { html, TemplateResult } from "lit-html";

export interface Props {
	content: TemplateResult;
	fitHeight?: boolean;
	onClick: () => void;
}

export const useLoginWidgetButton = (props: Props) => {
	const htmlTemplate = () => html`
		<div
			class=${classNames(
				"flex cursor-pointer flex-1 select-none flex-col items-center text-center justify-between rounded-lg border border-solid border-be-gray-9 p-3 text-sm/none text-n-blue",
				"sm:text-base/none",
				"md:hover:bg-gray-100",
				{
					"h-fit max-h-24": props.fitHeight,
					"min-h-[90px] sm:h-[106px]": !props.fitHeight,
				}
			)}
			@click=${props.onClick}
		>
			${props.content}
		</div>
	`;

	return { htmlTemplate };
};
